import { FC, ReactNode } from 'react';

import { Box } from '@chaos/ui/box';
import { useTheme } from '@chaos/ui';
import { SignInFooter } from '../signin-footer';
import { SigninBg } from '../signin-bg';

import logo from '../../assets/img/logo.svg';

interface SignInLayoutProps {
  children?: ReactNode
}

export const SignInLayout: FC<SignInLayoutProps> = ({ children }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <SigninBg />
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', flexGrow: 1,
      }}
      >
        <Box p={5}>
          <img src={logo} width="230" height="40" alt="Chaos Labs" />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            maxWidth: '560px',
            px: 2,
            [theme.breakpoints.up('sm')]: {
              px: 5,
            },
          }}
        >
          {children}
        </Box>
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          padding: 5,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <SignInFooter />
      </Box>
    </Box>
  );
};
